import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import './Reports.css';

const ReportStudents = () => {
  const [previewData, setPreviewData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    loadPreview();
  }, []);

  const loadPreview = async () => {
    setLoading(true);
    try {
      const response = await api.get('/students', { params: { is_active: true } });
      setPreviewData(response.data || []);
    } catch (error) {
      console.error('Error al cargar vista previa:', error);
      toast.error('Error al cargar vista previa');
      setPreviewData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      const token = localStorage.getItem('token');
      const baseUrl = api.defaults.baseURL || 'http://localhost:8000/api/v1';
      const url = `${baseUrl}/reports/students/excel`;
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Error al descargar el reporte');
      }
      
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `estudiantes_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success('Reporte descargado correctamente');
    } catch (error) {
      console.error('Error al descargar:', error);
      toast.error('Error al descargar el reporte');
    }
  };

  return (
    <div className="reports-page">
      <div className="page-header">
        <h2>👥 Lista de Estudiantes</h2>
        <p>Visualiza y exporta la lista completa de estudiantes</p>
      </div>

      {/* Vista previa */}
      <div className="card preview-section">
        <div className="preview-header">
          <h3>Vista Previa</h3>
          <div className="export-buttons">
            <button 
              className="btn btn-primary"
              onClick={handleDownload}
            >
              📊 Exportar a Excel
            </button>
          </div>
        </div>

        {loading ? (
          <div className="preview-loading">
            <p>Cargando vista previa...</p>
          </div>
        ) : !previewData || previewData.length === 0 ? (
          <div className="preview-empty">
            <p>No hay estudiantes registrados</p>
          </div>
        ) : (
          <div className="preview-table-container">
            <table className="preview-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre Completo</th>
                  <th>Documento</th>
                  <th>Email</th>
                  <th>Teléfono</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {previewData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map(student => (
                  <tr key={student.id}>
                    <td>{student.id}</td>
                    <td>{student.full_name}</td>
                    <td>{student.document_type} {student.document_number}</td>
                    <td>{student.email || '-'}</td>
                    <td>{student.phone || '-'}</td>
                    <td>
                      <span className={`status-badge ${student.is_active ? 'status-paid' : 'status-cancelled'}`}>
                        {student.is_active ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {previewData.length > 0 && (
              <div className="pagination-container">
                <div className="pagination-info">
                  Mostrando {Math.min((currentPage - 1) * itemsPerPage + 1, previewData.length)} - {Math.min(currentPage * itemsPerPage, previewData.length)} de {previewData.length} registros
                </div>
                <div className="pagination-controls">
                  <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                  >
                    « Primera
                  </button>
                  <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  >
                    ‹ Anterior
                  </button>
                  <span className="pagination-current">
                    Página {currentPage} de {Math.ceil(previewData.length / itemsPerPage)}
                  </span>
                  <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(previewData.length / itemsPerPage)))}
                    disabled={currentPage >= Math.ceil(previewData.length / itemsPerPage)}
                  >
                    Siguiente ›
                  </button>
                  <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(Math.ceil(previewData.length / itemsPerPage))}
                    disabled={currentPage >= Math.ceil(previewData.length / itemsPerPage)}
                  >
                    Última »
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportStudents;
